import styled from "styled-components";
import { Content } from "../../../../components/Calendar/styles";

export const Title = styled.h1`
  font-size: 0.75rem;
  color: ${({ theme }) => `${theme.colors.primary}`};
  text-align: center;
  margin-bottom: 3rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const Form = styled.form`
  width: 100%;
  margin-bottom: 0.5rem;

  > div {
    > & + div {
      margin-top: 0.25rem;
    }
  }

  > a {
    display: flex;
    justify-content: flex-end;
    color: ${({ theme }) => `${theme.colors.primary}`};
    margin: 1rem 0 4rem;
    text-decoration: none;
    font-size: 0.75rem;
  }

  @media (min-width: 768px) {
    > a {
      font-size: 0.875rem;
    }
  }
`;

export const FooterCard = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;

  svg + svg {
    margin-left: 1rem;
  }
`;

export const ContentCalendar = styled.div`
  margin: 1rem 0;

  ${Content} {
    position: relative;
  }
`;

// @media (min-width: 640px) { }

// @media (min-width: 768px) { }

// @media (min-width: 1280px) { }

// @media (min-width: 1536px) { }
